export default (value: number) => {
    switch (value) {
        case 10:
            return "Pending";
        case 80:
            return "Failed";
        case 90:
            return "Completed";
        default:
            return "Unknown";
    }
}
